<div class="container-fluid contribution">
    <div
        *ngIf="projectType && projectEnded"
        class="row d-flex justify-content-around buttonGroupContrib mt-2 py-3 mb-4 mx-5"
    >
        <div class="col-sm">
            <button class="btn pb-2" nbButton status="success">
                {{ projectType }}
            </button>
            <img
                class="img-responsive img-fluid"
                src="../../assets/images/image 11.png"
            />
            <button class="btn ended" nbButton status="danger">
                {{ projectEnded }}
            </button>
        </div>
    </div>
    <div class="row counter-container">
        <div *ngIf="!isConnected" class="countdown walletNotConnectedView">
            <nb-card class="">
                <nb-card-body>
                    <div class="row justify-content-between">
                        <div class="col">
                            <h3>Sale starts in:</h3>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-sm">
                            <hr />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <h5>
                                {{ _timerService._days + ":"
                                }}{{ _timerService._hours + ":"
                                }}{{ _timerService._minutes + ":"
                                }}{{ _timerService._seconds }}
                            </h5>
                        </div>
                    </div>
                    <div class="row justify-content-center pt-3">
                        <div class="col">
                            <button
                                class="btn connectWallet"
                                nbButton
                                status="primary"
                                disabled
                                (click)="openDialog()"
                                [disabled]="isConnected"
                            >
                                Connect Wallet
                            </button>
                        </div>
                    </div>
                </nb-card-body>
            </nb-card>
        </div>
        <div *ngIf="isConnected" class="countdown walletConnectedView">
            <nb-card class="">
                <nb-card-body>
                    <div class="row justify-content-between">
                        <div class="col">
                            <h3 *ngIf="!stageActive">Sale starts in:</h3>
                            <h3 *ngIf="stageActive">Sale started before:</h3>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-sm">
                            <hr />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <h5>
                                {{ _timerService._days | absolute }}:{{
                                    _timerService._hours | absolute
                                }}:{{ _timerService._minutes | absolute }}:{{
                                    _timerService._seconds | absolute
                                }}
                                <!-- {{ _timerService._days + ":"
                                }}{{ _timerService._hours + ":"
                                }}{{ _timerService._minutes + ":"
                                }}{{ _timerService._seconds }} -->
                            </h5>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="progressBarFirstSale">
                                <nb-progress-bar
                                    [value]="saleStartPercentage"
                                    status="success"
                                    size="giant"
                                >
                                </nb-progress-bar>
                            </div>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col">
                            <div class="progressBarSecondSale">
                                <nb-progress-bar
                                    [value]="availableAmountPercentage"
                                    status="success"
                                    size="giant"
                                >
                                </nb-progress-bar>
                            </div>
                        </div>
                    </div>
                    <div class="row tokenPrice pt-2">
                        <div class="col">
                            <div class="d-flex justify-content-between">
                                <p>0 XYZ</p>
                                <p>1 BYND = 150XYZ</p>
                            </div>
                        </div>
                    </div>
                    <div class="row justify-content-center pt-3">
                        <div class="col">
                            <button
                                class="btn connectWallet"
                                nbButton
                                status="primary"
                                disabled
                            >
                                Approve
                            </button>
                        </div>
                    </div>
                    <div class="row justify-content-center pt-3">
                        <div class="col">
                            <button
                                class="btn connectWallet"
                                nbButton
                                status="primary"
                                disabled="isConnected"
                                disabled
                            >
                                Buy
                            </button>
                        </div>
                    </div>
                </nb-card-body>
            </nb-card>
        </div>
    </div>

    <div class="row mx-5">
        <div class="col-sm">
            <div class="row pt-5">
                <div class="col-sm-12 col-lg-12 mainCol">
                    <div *ngIf="isConnected" class="contribWalletConnView mb-5">
                        <div class="row">
                            <div class="col-sm">
                                <h3>Your contribution</h3>
                                <hr class="hrWalletConnected" />
                                <br />
                                <!-- <h3 class='biggerH3'>0.00XYZ</h3> -->
                                <h3 class="biggerH3">
                                    {{ userContribAmount }}
                                </h3>
                            </div>
                            <div class="col colSecond">
                                <p>Token Price</p>
                                <hr class="hrWalletConnected" />
                                <br />
                                <p>1 BYND = $0.0{{ tokenPrice }}</p>
                            </div>
                            <div class="col colSecond">
                                <p>Token Raise</p>
                                <hr class="hrWalletConnected" />
                                <br />
                                <p>$2,500,000</p>
                            </div>
                        </div>
                    </div>
                    <h2>Beyondi Crowdsale</h2>
                    <div class="d-flex justify-content-start pb-5 pt-2">
                        <a href="https://www.instagram.com/beyondi.bbd/">
                            <i class="fa-brands fa-instagram fa-lg brand"></i
                        ></a>
                        <a href="https://hr.linkedin.com/company/beyondi">
                            <i class="fa-brands fa-linkedin fa-lg brand"></i
                        ></a>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <nb-tabset class="tabset-intro" fullWidth>
                        <nb-tab tabTitle="Description">
                            <h4>Introduction</h4>
                            <p>
                                The mission of Beyondi Crowdsale is to empower
                                project developers with a decentralized initial
                                DEX offering (IDO) platform and incubation
                                services on the Cronos Network that features
                                security and anti-whale system mechanics to
                                protect investors, ensuring project stability
                                throughout the entire life cycle. One of the
                                main goals of our platform is to provide every
                                investor in the space, regardless of their
                                experience, with access to high-quality,
                                carefully vetted projects backed by
                                enthusiastic, hardworking professionals who are
                                certain to deliver on their promises.
                            </p>
                            <p>
                                One of our main goals is to provide access for
                                every investor in the space, no matter what
                                experience, with high quality curated projects
                                that are backed by passionate hardworking
                                professional that will deliver on their
                                promises.
                            </p>
                            <br />
                            <h4>Problem</h4>
                            <p>
                                Currently, the projects introduced to the crypto
                                space lack the guarantee of quality and
                                accountability. On top of that, whale investors
                                are unfairly seizing control of every tiered
                                system and investment opportunity. And if that
                                wasn't enough, the infrastructure of IDO and ICO
                                platforms is often characterized by a lack of
                                security, stability, and responsiveness, putting
                                each participant's investments at risk.
                            </p>
                            <br />
                            <h4>Solution</h4>
                            <p>
                                Beyondi was designed to address the problems
                                plaguing the community. The launchpad and
                                project incubation platform intensely vets
                                projects, teams, and contracts to ensure quality
                                over quantity. It also offers project incubation
                                to maximize exposure, potential growth, and
                                project longevity. Additionally, LitBit
                                implements security protocols that protect the
                                community utilizing its token vault and
                                liquidity lockers, as well as providing an equal
                                chance for every investor with its anti-whale
                                lottery system.
                            </p>
                        </nb-tab>
                        <nb-tab tabTitle="Tokensale details">
                            <ngx-token-sale-details></ngx-token-sale-details>
                        </nb-tab>
                        <!-- <nb-tab tabTitle="Recent transactions">
                            <ngx-recent-transactions></ngx-recent-transactions>
                        </nb-tab> -->
                    </nb-tabset>
                </div>
            </div>

            <div class="row pt-5">
                <div class="col-sm-12 col-xl-8">
                    <h3>About</h3>
                </div>
            </div>

            <div class="row pt-3 mb-4">
                <div class="col-sm-12 col-lg-2">
                    <h4 class="mb-0">Website</h4>
                    <hr />
                    <br />
                    <!-- TODO: Remove br tags b4 prod-->
                    <p>www.example.com</p>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-lg-2">

                </div>
                <div class="col-lg-4 pl-5">

                </div>
            </div> -->
        </div>
    </div>
</div>
